import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConfirmationDialogComponent} from "./confirmation-dialog.component";
import {MatDialogModule} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";

const dependencies = [
    MatDialogModule,
    MatButtonModule
]

@NgModule({
    declarations: [
        ConfirmationDialogComponent
    ],
    imports: [
        CommonModule,
        ...dependencies
    ],
    exports: [
        ConfirmationDialogComponent
    ]
})
export class ConfirmationDialogModule {
}
